/**
 * Shared design tokens for the Feed post cards (FeedCard, YardSignPost) so
 * every post type in the feed — regardless of underlying data model — reads
 * as one consistent visual system instead of drifting per-component.
 */
export const TOKENS = {
  surface: "#FFFFFF",
  surface2: "#F8FAFD",
  line: "#E7E9EE",
  hairline: "#EFF1F5",
  ink: "#0B1320",
  ink2: "#2A3142",
  muted: "#6B7388",
  faint: "#9AA1B0",
  primary: "#2563EB",
  primarySoft: "#EAF1FF",
  good: "#16A77A",
  goodSoft: "#E7F6EE",
  bad: "#C2453A",
  goldDark: "#8A5A05",
  goldMid: "#B98515",
  purple: "#7E22CE",
  purpleSoft: "#F4EBFE",
  coral: "#D8431A",
  coralSoft: "#FEEEE8",
};

export const FONT = '"DM Sans", "Inter", "Arial", sans-serif';
export const NUM_FEATURES = '"tnum" 1, "lnum" 1';
